import { Api } from 'eosjs'
import { sleep } from '@/lib/common'
import type { EosAccount, EosAction, EosConfig, TransactionResult, WalletAdapter } from '@/types'

declare global {
  interface Window {
    scatter?: any
  }
}

let loaded = false
document.addEventListener('scatterLoaded', () => { loaded = true })

export class TokenPocketWallet implements WalletAdapter {
  private api: any = null
  private accounts: EosAccount[] = []

  async connect(config: EosConfig, rpc: unknown): Promise<EosAccount[]> {
    const network = {
      blockchain: 'eos',
      chainId: config.chainId,
      rpc: config.rpcUrl,
    }
    let times = 0
    while (!loaded && times < 100) {
      await sleep(100)
      times++
    }
    if (!loaded) throw new Error('no tokenpocket')
    this.api = (window as any).scatter.eos(network, Api, { rpc })
    if (!this.accounts.length) {
      await this.login()
    }
    return this.accounts
  }

  async login(): Promise<EosAccount[]> {
    if (this.accounts.length > 0) return this.accounts
    const identity = await (window as any).scatter.login()
    if (!identity) return []
    this.accounts = identity.accounts
    return this.accounts
  }

  async logout(): Promise<void> {
    this.accounts = []
    await (window as any).scatter.logout()
  }

  async transact(actions: EosAction[]): Promise<TransactionResult> {
    const options = { blocksBehind: 3, expireSeconds: 120 }
    return this.api.transact({ actions }, options)
  }
}
